import Lookup from 'src/componentes/select2';

const StatusColaborador = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/StatusColaboradorLookup"
      {...props}
    />
  );
};

export default StatusColaborador;
